import { post } from '@/util/request'

export default {
  /**
   * 获取短信验证码
   * @param query
   * @returns {*}
   */
  sendVerifyCode: query => post(`/trial/sendVerifyCode`, query),
  /**
   * 储存申请试用信息
   * @param query
   * @returns {*}
   */
  save: query => post(`/trial/save`, query),

}
